import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage   from "./homepage";
import Demo       from "./demo";
import Order      from "./order";
import CekOrder   from "./cek-order";
import Undangan   from "./undangan";
import Pantau     from "./pantau";
import Admin      from "./admin";
import Reseller   from "./reseller";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"               element={<Homepage />} />
        <Route path="/demo"           element={<Demo />} />
        <Route path="/demo/:themeId"  element={<Demo />} />
        <Route path="/order"          element={<Order />} />
        <Route path="/cek-order"      element={<CekOrder />} />
        <Route path="/undangan/:slug" element={<Undangan />} />
        <Route path="/pantau/:slug"   element={<Pantau />} />
        <Route path="/admin"          element={<Admin />} />
        <Route path="/reseller"       element={<Reseller />} />
      </Routes>
    </BrowserRouter>
  );
}
